<template>
    <div class="dt-panelmenu clearfix">
        <div class="dataTables_length">
            <label>
                Показывать по
                <vue-select
                    v-on:input="go"
                    :options="counts"
                    v-model="currentPerPage"
                    :searchable="false"
                    :clearable="false"
                    label="options"
                    :reduce="options => options"
                />
                записей
            </label>
        </div>
    </div>
</template>

<script>
    import Helper from "../../../classes/Helper";

    export default {
        components: {
            vueSelect: () => import('vue-select'),
        },

        props: {
            perPage: Number,
            counts: {
                type: Array,
                default: function() {
                    return [10, 25, 50, 100];
                },
            },
            queryName: {
                type: String,
                default: 'per-page',
            },
            pageQueryName: {
                type: String,
                default: 'page',
            },
        },
        data() {
            return {
                currentPerPage: this.perPage,
            };
        },
        watch: {
            perPage: function(value) {
                this.currentPerPage = value;
            },
        },
        methods: {
            getRoute() {
                const route = {
                    name: this.$route.name,
                    params: this.$route.params,
                    query: this.$route.query,
                };

                return Helper.copyObject(route);
            },
            go() {
                const to = this.getRoute();
                to.query[this.queryName] = this.currentPerPage;
                to.query[this.pageQueryName] = undefined;
                this.$router.push(to);
                this.$emit('update');
            },
        },
    }
</script>
